import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import { BaseModal } from '@repo/components/modals';
import { selectActivityItemInModal } from '@repo/redux/actions/ui';
import { Pill } from '@repo/components/containers';
import renderPostMarkdown from '@views/Activity/ActivityListItem/Announcements/renderMarkdown';
import styles from './ExpandedActivityItem.module.scss';
import { ArrowRightIcon, XIcon } from '@repo/icons';
import { SmallLinkButton } from '@components/Button';
import { ActivityItem } from '@repo/utils/models/Activity';
import { renderSocialDiffMarkdown } from '@repo/utils/helpers/markdown';

const ExpandedPost = ({ activityItem }: { activityItem: ActivityItem }) => {
  const { content, media } = activityItem.metadata || {};

  return (
    <div className={styles.itemContent}>
      {renderPostMarkdown(content)}
      {media?.length > 0 && (
        <div className={styles.imageGroup}>
          {media.slice(0, 3).map(({ thumbnail }, _, renderedImages) => (
            <div
              key={thumbnail}
              className={cn(styles.image, renderedImages.length === 1 && styles.noRotation)}
            >
              <img src={thumbnail} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const ExpandedDiff = ({ activityItem }: { activityItem: ActivityItem }) => (
  <div className={styles.itemContent}>{renderSocialDiffMarkdown(activityItem.metadata)}</div>
);

export default function ExpandedActivityItemModal(props) {
  const activityItem = useSelector(selectActivityItemInModal);
  const { contact, link, source } = activityItem.metadata || {};

  useEffect(() => {
    if (!activityItem) {
      props.closeModal();
    }
  }, []);

  if (!activityItem) {
    return null;
  }

  return (
    <BaseModal isOpen={true} onRequestClose={props.closeModal} containerClassName={styles.modal}>
      <div className={cn('modal-header', styles.header)}>
        <Pill contact={contact} maxWidth={160} clickable />
        <button className={styles.closeBtn} onClick={props.closeModal} aria-label="Close">
          <XIcon />
        </button>
      </div>
      {activityItem.type === 'post' && <ExpandedPost activityItem={activityItem} />}
      {activityItem.type === 'diff' && <ExpandedDiff activityItem={activityItem} />}
      <SmallLinkButton className={styles.goToPost} href={link} target="_blank">
        Via {source}
        <ArrowRightIcon className={styles.arrowIcon} />
      </SmallLinkButton>
    </BaseModal>
  );
}
